'use client'

import { PoliticianCard } from '@/components/PoliticianCard'

import type { Bill, Legislator } from '@/payload-types'

/**
 * Lists BillTrack50 sponsors for a bill, linking to legislators when populated.
 */
export function BillSponsorsSection({ bill }: { bill: Bill }) {
  const sponsors = bill.bt50?.sponsors ?? []
  const heading = sponsors.length === 1 ? 'Sponsor' : 'Sponsors'

  return (
    <div>
      <h3 className="my-2 text-2xl font-medium text-foreground">{heading}</h3>
      {!sponsors.length ? (
        <p className="m-0 p-0 font-body text-base leading-6 font-normal text-foreground">
          No sponsors associated with this bill.
        </p>
      ) : (
        <div className="mt-3 mb-6 flex flex-wrap items-stretch justify-start gap-3">
          {sponsors.map((sponsor, index) => {
            const legislator = sponsor.legislator
            if (typeof legislator === 'object' && legislator !== null && 'id' in legislator) {
              return <PoliticianCard key={sponsor.id ?? index} politician={legislator as Legislator} />
            }

            const name = sponsor.name ?? 'Sponsor'
            return (
              <div
                key={sponsor.id ?? `${name}-${index}`}
                className="rounded-xl border border-border bg-white px-4 py-3 font-body text-base text-foreground"
              >
                {name}
                {sponsor.primary ? ' (Primary)' : ''}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
